// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604101103/js/" + chunkId + "." + {"44":"0396c830","225":"e82b1329","481":"264891e0","486":"1c337128","770":"e8bcc9f9"}[chunkId] + ".0.29437359919237704.chunk.js";
};